/**
 * Tax regime SAT code (catalog key). The human-readable description
 * is resolved at the presentation layer from the fiscal regimes catalog.
 */
export type TaxRegime = Readonly<string>;

/**
 * Creates a validated TaxRegime value object.
 *
 * @param satCode - SAT regime code (e.g. "601", "605")
 * @returns Validated TaxRegime
 * @throws Error if satCode is empty
 */
export const createTaxRegime = (satCode: string): TaxRegime => {
  if (!satCode?.trim()) {
    throw new Error('Tax regime SAT code is required');
  }
  return satCode as TaxRegime;
};
